<template>
  <v-row align="center" justify="center" class="mt-6 pa-3">
    <v-card max-width="100%" width="300" flat color="background">
      <v-row align="center" justify="center">
        <v-carousel id="v-carousel-rating" cycle height="150" hide-delimiter-background show-arrows-on-hover :show-arrows="false" delimiter-icon="">
          <v-carousel-item v-for="(rating, i) in ratings" :key="i">
            <v-sheet class="containerCustom" light  width="100%" height="90px">

              <v-row >
                <v-row align="center" justify="center" class="mb-4">
                  <v-card  width="90" height="90" elevation="5" class="roundedCard">
                    <img class="imgUserProfile" v-bind:src="rating.provider.urlPhoto" />
                  </v-card>
                   <v-list-item-avatar class="containerRating">
                    <v-row class="">
                      <h5 class="text-center d-flex align-center justify-center textRating">{{rating.score}}</h5>
                    </v-row>
                     <v-row style="margin-left:0px;margin-right: 8px;" >
                      <img src="../assets/star.svg"/>
                    </v-row>
                   </v-list-item-avatar>
                </v-row>
                <v-col cols="8">
                  <v-row >
                    <h3 v-if="rating.provider.name && rating.provider.lastName"
                      class="textProviderName text-center d-flex align-center justify-center "
                    >{{ rating.provider.name }} {{ rating.provider.lastName }}</h3>
                    <h3 v-else
                      class="textProviderName text-center d-flex align-center justify-center "
                    >Sin nombre</h3>
                  </v-row>
                  <v-row class="textSpacing" >
                    <p
                      class="textLigth text-center d-flex align-center justify-center "
                    > 💸 ${{ (rating.provider.company) ? rating.provider.company.pricePerLiter: 0.00}}</p>
                  </v-row>
                  <v-row >
                    <p
                      class="textLigth text-center d-flex align-center justify-center "
                    > 🔥 {{ (rating.provider.company) ? rating.provider.company.name: 'NA' }}</p>
                  </v-row>
                </v-col>
              </v-row>

            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-row>
    </v-card>
  </v-row>
</template>

<script>
import ratingsLocal from "../statics/ratingsProviders.json";
import Axios from "axios";
import config from "../config"

export default {
  data() {
    return {
      ratings: [],
    };
  },
  mounted(){
    this.getRatingsProviders(this)
  },
  methods: {
    async getRatingsProviders(vue){
       let api = Axios.get(config.apiBaseUrl + "/provider/top-score", {
          headers: {
            "x-api-key": config.apiKey,
          },
        })
          .then((response) => {
            if (response.status === 200) {
              let { data } = response;
              data.forEach(element => {
                if(!element.provider.urlPhoto){
                  element.provider.urlPhoto = require("../assets/usuario.svg") ;
                }
              });
              vue.ratings = data;
            }
          })
          .catch((error) => {
            console.error(error);
          });
    }
  }
};
</script>

<style scoped>
.textColor {
  font-size: 16px!important;
  font-weight: bold!important;
  font-stretch: normal!important;
  font-style: normal!important;
  line-height: normal!important;
  letter-spacing: -0.01px!important;
  text-align: center!important;
  color: #5932fd!important;
}



.textBlack {
  font-weight: normal!important;
  color: #303034!important;
  
}

.textoRating {
  width: 364px;
  height: 125px;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.02px;
  text-align: center;
  color: #303034;
}

.containerRating{
  height: 20px !important;
  min-width: 50px !important;
  border: 0px !important;
  border-radius: 4px !important;
  top: 73px !important;
  position: absolute !important;
  background-color: #28d7d8 !important;
}

.containerRating > div{
  margin: 5px 2px 5px 10px;
}

.textRating{
  font-size: 12px;
  letter-spacing: -0.01px;
  color: #ffffff;
  margin: 0px auto;
}

.containerCustom{
  border-radius: 60px 8px 8px 60px !important;
  background: linear-gradient(100deg, rgb(255 255 255 / 0%) 0%, rgb(255 255 255) 31%);
}

.containerCustom > div{
  padding-top: 0px;
}

.imgUserProfile{
  width: 90px;
  height: 90px;
  padding: 2px;
}

.roundedCard{
    border-radius:50px;
    left: 7px;
}

.textLigth{

  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.01px;
}

.textSpacing{
  height: 20px;
}

.textProviderName{
  font-size: 13px;
}


</style>